/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface ExcludeAppointmentDayRequest
 */
export interface ExcludeAppointmentDayRequest {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof ExcludeAppointmentDayRequest
     */
    teacherId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {Date}
     * @memberof ExcludeAppointmentDayRequest
     */
    date: Date;
    /**
     * 
     * @type {string}
     * @memberof ExcludeAppointmentDayRequest
     */
    startTime: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExcludeAppointmentDayRequest
     */
    endTime: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExcludeAppointmentDayRequest
     */
    reason: string | null;
}

/**
 * Check if a given object implements the ExcludeAppointmentDayRequest interface.
 */
export function instanceOfExcludeAppointmentDayRequest(value: object): value is ExcludeAppointmentDayRequest {
    if (!('teacherId' in value) || value['teacherId'] === undefined) return false;
    if (!('date' in value) || value['date'] === undefined) return false;
    if (!('startTime' in value) || value['startTime'] === undefined) return false;
    if (!('endTime' in value) || value['endTime'] === undefined) return false;
    if (!('reason' in value) || value['reason'] === undefined) return false;
    return true;
}

export function ExcludeAppointmentDayRequestFromJSON(json: any): ExcludeAppointmentDayRequest {
    return ExcludeAppointmentDayRequestFromJSONTyped(json, false);
}

export function ExcludeAppointmentDayRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExcludeAppointmentDayRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'teacherId': ApiUserTasksGetPageParameterFromJSON(json['teacherId']),
        'date': (new Date(json['date'])),
        'startTime': json['startTime'],
        'endTime': json['endTime'],
        'reason': json['reason'],
    };
}

export function ExcludeAppointmentDayRequestToJSON(json: any): ExcludeAppointmentDayRequest {
    return ExcludeAppointmentDayRequestToJSONTyped(json, false);
}

export function ExcludeAppointmentDayRequestToJSONTyped(value?: ExcludeAppointmentDayRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'teacherId': ApiUserTasksGetPageParameterToJSON(value['teacherId']),
        'date': value['date'].toISOString().substring(0,10),
        'startTime': value['startTime'],
        'endTime': value['endTime'],
        'reason': value['reason'],
    };
}

